/**
 * Builds a URL with query parameters
 * @param {string} baseUrl - The base URL
 * @param {Object} params - Object containing query parameters
 * @returns {string} - URL with query parameters
 */
export const getURLWithParams = (baseUrl, params = {}) => {
  if (!params || Object.keys(params).length === 0) {
    return baseUrl;
  }
  
  const searchParams = new URLSearchParams();
  
  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      // Handle array parameters (e.g., categories)
      value.forEach(val => {
        if (val !== undefined && val !== null && val !== '') {
          searchParams.append(key, val);
        }
      });
    } else if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value);
    }
  });
  
  const queryString = searchParams.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}; 